import { applyMiddleware, compose, legacy_createStore as createStore, type Store } from 'redux';
import thunk from 'redux-thunk';

import { ENV } from 'shared/config';

import rootReducer from '../reducers';

const composeEnhancers =
  ENV.IS_DEV_SERVER && (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    : compose;

const enhancer = applyMiddleware(thunk);

const store = createStore(rootReducer, composeEnhancers(enhancer)) as Store;

export default store;
